import { inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '@modules/error-dialog/components/error-dialog/error-dialog.component';

export function showInvalidInputErrorDialogInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const dialog = inject(MatDialog);

  return next(req).pipe(
    catchError((err: any) => {
      if (isBadRequestDtoHttpErrorResponse(err)) {
        dialog.open(ErrorDialogComponent, {
          data: {
            title: err.error.error,
            message: err.error.message,
            details: err.error.details,
          }
        });
      }

      throw err;
    }),
  );
}

export function isBadRequestDtoHttpErrorResponse(err: any) {
  return err instanceof HttpErrorResponse && err.status === 400 && !!err?.error?.error && !!err?.error?.message;
}
